import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getLocalFranchiseStore, getStoreLocalData, getUserData } from "../../../utils/localStorage";
import AdminMenu from "../../AdminMenu";
import { getBrandStore } from "../../../services/StoreUsers/PostStoreUsers";

import {
  Doughnut,
} from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  ArcElement,
  RadarController,
  Tooltip,
  Title,
  Legend,
  RadialLinearScale,
} from "chart.js";
import { ProgressSpinner } from "primereact/progressspinner";
import StoreFilterModal from "../../StoreFilterModal";
import AnalyticsSchedularModal from "../../AnalyticsSchedularModal";
import { formatDateNew, localeDateEndDate, localeDateStartDate } from "../../../constants/DateUtil/DateUtil";
import { getAnalyticsStoreOrderByStatus } from "../../../services/DashboardAPI/DashboardApi";

// Register components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  ArcElement,
  RadarController,
  Tooltip,
  Title,
  Legend,
  RadialLinearScale
);

const ProcessStatus = () => {
  const navigate = useNavigate();

  const [visible, setVisible] = useState(false);

  const { userProfileRole, brandProfileData } = getUserData();
  const { storeLocalData } = getStoreLocalData();
  const userRole = userProfileRole;
  const brandId = brandProfileData.id;
  let initialStartDate = new Date();
  initialStartDate.setDate(initialStartDate.getDate()); // subtract 7 days to current date

  // If orderFilterData is available, use its start and end dates
  const [startDate, setStartDate] = useState(new Date(initialStartDate));
  let initialEndDate = new Date();
  const [endDate, setEndDate] = useState(new Date(initialEndDate));
  const [analyticsSchedularModalVisible, setAnalyticsSchedularModalVisible] =
    useState(false);
  const [schedularDate, setSchedularDate] = useState({});

  const receiveDataFromSchedularModal = ({newSchedular}) => {
    setSchedularDate(newSchedular);
    setInitialDateValue(newSchedular.startDate)
    setEndDate(newSchedular.endDate)
  };

  const handleCalendarModal = () => {
    setAnalyticsSchedularModalVisible(true);
  };
  const [loading, setLoading] = useState(false);
  const [grandTotalChart, setGrandTotalChart] = useState([]);
  const [orderCountChart, setOrderCountChart] = useState([]);

  const [grandTotalChartNew, setGrandTotalChartNew] = useState({});
  const [orderCountChartNew, setOrderCountChartNew] = useState({});

  const [sumOfGrandTotal, setSumOfGrandTotal] = useState(0);
  const [sumOfOrderCount, setSumOfOrderCount] = useState(0);
  const [storeSelectionModalVisible, setStoreSelectionModalVisible] =
    useState(false);
  const [upDateSelectedStore, setUpDateSelectedStore] = useState([]); // Default to show all orders
  const [brandStoreData, setBrandStoreData] = useState([]);
  const [selectedStore, setSelectedStore] = useState('ALL');
  
  // const [sumOfChargeAmountSumData, setSumOfChargeAmountSumData] = useState(0)
  // const [sumOfDiscountAmountSumData, setSumOfDiscountAmountSumData] = useState(0)
  // const [sumOfTotalAmountSumData, setSumOfTotalAmountSumData] = useState(0)
  // const [sumOfTaxableAmountSumData, setSumOfTaxableAmountSumData] = useState(0)
  // const [sumOfGstAmountSumData, setSumOfGstAmountSumData] = useState(0)

  // const [sumOfTotalOrderChargeDiscountSumData,setSumOfTotalOrderChargeDiscountSumData] = useState(0);
  // const [sumOfTotalBalanceAmountSumData,setSumOfTotalBalanceAmountSumData] = useState(0);
  // const [sumOfTotalRefundAmountSumData,setSumOfTotalRefundAmountSumData] = useState(0);
  // const [sumOfTotalTotalDeliveryDiscountSumData,setSumOfTotalTotalDeliveryDiscountSumData] = useState(0);
  // const [sumOfTotalTotalDeliveryChargeSumData,setSumOfTotalTotalDeliveryChargeSumData] = useState(0);
  // const [sumOfTotalOfferDiscountSumData,setSumOfTotalOfferDiscountSumData] = useState(0);
  // const [sumTotalSubscriptionDiscountSumData,setSumTotalSubscriptionDiscountSumData] = useState(0);

  const chartsGradient = [
    '#006DFF',
    '#3BE9DE',
    '#8F80F3',
    '#FF7F97',
    '#F6D173',
    '#009596',
    '#EC7A08',
    '#58508d',
    '#bc5090',
    '#ff6361',
    '#ffa600',
  ];

  const chartsColor = [
    '#006DFF',
    '#3BE9DE',
    '#8F80F3',
    '#FF7F97',
    '#F6D173',
    '#009596',
    '#EC7A08',
    '#58508d',
    '#bc5090',
    '#ff6361',
    '#ffa600',
  ];

  const initializeVariable = () => {
    setGrandTotalChart([]);
    setOrderCountChart([]);
    setSumOfGrandTotal(0);
    setSumOfOrderCount(0);
  };

  const receiveDataFromStoreSelectionModal = selectedStore => {
    setSelectedStore(selectedStore);
  };

  const fetchStoreOrders = data => {
    setLoading(true);
    getAnalyticsStoreOrderByStatus(brandId, data)
      .then(response => {
        if (!response.data.error) {
          const Res = response.data;
          const statusTotals = Res.reduce((acc, order) => {
            // Check if the status already exists in the accumulator
            const existingStatus = acc.find(
              item => item.status === order.status,
            );

            if (existingStatus) {
              existingStatus.totalOrder += order.totalOrder;
              existingStatus.totalSale += order.totalSale;
            } else {
              // If status does not exist, create a new object with the status, grandTotal, and order count
              acc.push({
                status: order.status,
                totalOrder: order.totalOrder,
                totalSale: order.totalSale,
              });
            }

            return acc;
          }, []);

          const grandTotalSumData = statusTotals.map((item, index) => ({
            ...item,
            name: item.status,
            value:item.totalSale,
            gradientCenterColor: chartsGradient[index % chartsGradient.length], // Assuming getRandomColor() generates a random color
            color: chartsColor[index % chartsColor.length],
          }));

          const orderCountData = statusTotals.map((item, index) => ({
            ...item,
            name: item.status,
            value: item.totalOrder,
            gradientCenterColor: chartsGradient[index % chartsGradient.length], // Assuming getRandomColor() generates a random color
            color: chartsColor[index % chartsColor.length],
          }));

          const grandTotalSumDataNew = {
            labels: grandTotalSumData?.map((item) =>
              item.name.replace(/_/g, " ")
            ),
            datasets: [
              {
                label: ["Revenue"],
                data: grandTotalSumData?.map((item) => item.value),
                backgroundColor: grandTotalSumData?.map(
                  (item) => item.gradientCenterColor
                ),
              },
            ],
          };

          const orderCountDataNew = {
            labels: orderCountData?.map((item) =>
              item.name.replace(/_/g, " ")
            ),
            datasets: [
              {
                label: ["Revenue"],
                data: orderCountData?.map((item) => item.value),
                backgroundColor: orderCountData?.map(
                  (item) => item.gradientCenterColor
                ),
              },
            ],
          };


          const totalGrandTotalSumData = statusTotals.reduce(
            (acc, item) => acc + item.totalSale,
            0,
          );
          const totalOrderCountData = statusTotals.reduce(
            (acc, item) => acc + item.totalOrder,
            0,
          );

          setGrandTotalChart(grandTotalSumData);
          setOrderCountChart(orderCountData);

          setGrandTotalChartNew(grandTotalSumDataNew);
          setOrderCountChartNew(orderCountDataNew);

          setSumOfGrandTotal(totalGrandTotalSumData);
          setSumOfOrderCount(totalOrderCountData);

          setLoading(false);
        }
      })
      .catch(err => {
        console.error('Error:', err);
      });
  };

  const initialDate = new Date(startDate);
  initialDate.setDate(initialDate.getDate() - 30);

  const [initialDateValue, setInitialDateValue] = useState(initialDate)
  
  useEffect(() => {
      initializeVariable();
      const fetchData = async () => {
        try {
          const response = await getBrandStore(brandId);
          if (!response.data.error) {
            const Res = response.data;
            setBrandStoreData(Res);
            const brandStoreData = response.data;
            const storeIds = brandStoreData.map(item => item.id);
            const data = {
              brandId: brandId,
              storeIds: selectedStore !== 'ALL' ? selectedStore : storeIds,
              statusIn: [
                'BOOKED',
                'INPROCESS',
                'IN_WAREHOUSE',
                'PROCESSED',
                'DELIVERED',
                'DONE',
                'OUT_FOR_DELIVERY',
              ],
              recordType: '',
              // startDate: schedularDate?.startDate
              //   ? schedularDate.startDate
              //   : brandProfileData.createdDate !== null
              //   ? brandProfileData.createdDate
              //   : '2024-01-01T00:00:00Z',
              startDate: schedularDate?.startDate
                ? localeDateStartDate(new Date(schedularDate.startDate))
                : localeDateStartDate(new Date(initialDate)),
              endDate: schedularDate?.endDate ? localeDateEndDate(new Date(schedularDate.endDate)) : localeDateEndDate(new Date(endDate)),
            };
            fetchStoreOrders(data);
            // setUpDateSelectedStore([]);
          }
        } catch (error) {
          console.error('Error:', error);
        }
      };

      const fetchFranchiseStore = async () => {
                           const franchiseStore = await getLocalFranchiseStore();
                           if (franchiseStore.franchiseStore !== null) {
                             const Res = franchiseStore.franchiseStore.filter((item) => item.status === "ACTIVE");
                             setBrandStoreData(Res);
                             const storeIds = Res.map((item) => item.id);
                             const data = {
                               brandId: brandId,
                               storeIds:
                                 selectedStore !== "ALL"
                                   ? selectedStore
                                   : storeIds,
                               statusIn: [
                                 "BOOKED",
                                 "INPROCESS",
                                 "IN_WAREHOUSE",
                                 "PROCESSED",
                                 "DELIVERED",
                                 "DONE",
                                 "OUT_FOR_DELIVERY",
                               ],
                               recordType: "",
                               // startDate: schedularDate?.startDate
                               //   ? schedularDate.startDate
                               //   : brandProfileData.createdDate !== null
                               //   ? brandProfileData.createdDate
                               //   : '2024-01-01T00:00:00Z',
                               startDate: schedularDate?.startDate
                                 ? localeDateStartDate(new Date(schedularDate.startDate))
                                 : localeDateStartDate(new Date(initialDate)),
                               endDate: schedularDate?.endDate
                                 ? localeDateEndDate(new Date(schedularDate.endDate))
                                 : localeDateEndDate(new Date(endDate))
                             };
                             fetchStoreOrders(data);
                           }   else {
                            setBrandStoreData([]);
                           }
                         };

      if (userRole === "BY_FRANCHISE_ADMIN") {
        fetchFranchiseStore();
      } else {
        fetchData();
      }
    }, [schedularDate, selectedStore]);


  const chartOptions = {
    responsive: true,
    plugins: { legend: { position: "bottom" } },
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/AnalyticsList")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">
              Process Status
              </p>
            </div>
          </div>

          <div
            onClick={() => handleCalendarModal()}
            className="flex justify-content-center align-items-center cursor-pointer mr-4"
          >
            <img
              src={"Laundy_App_Icons_Gifs/Other_Icons/schedule.png"}
              style={{ width: 27 }}
              alt="schedule"
            />
          </div>
          <div
            onClick={() => setStoreSelectionModalVisible(true)}
            className="mx-2 cursor-pointer"
          >
            <img
              src={"Laundy_App_Icons_Gifs/Other_Icons/filter.png"}
              style={{ width: 30 }}
              alt="filter"
            />
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div class="flex flex-1 justify-content-center align-items-center">
       <p className=" text-2xl  font-bold ">Period - {formatDateNew(initialDateValue)} - {formatDateNew(endDate)}</p>
      </div>
      <div className="flex flex-1">
        <div className="flex-1">
          <div
            className="flex-1  surface-0"
            style={{ "--surface-0": "#EAEFF5" }}
          >
            <div className="flex justify-content-center mx-4">
              <div className="py-1">
                <p className=" text-2xl  font-bold ">ALL ORDERS</p>
              </div>
            </div>
          </div>

          {loading ? (
            <div className="flex flex-1 flex-column justify-content-center align-items-center">
              <ProgressSpinner />
              <p className="text-3xl font-bold">
                Loading All Orders...
              </p>
            </div>
          ) : orderCountChart.length > 0 ? (
            <div>
              <div className="mx-4 my-3 flex justify-content-center">
                <div className="flex " style={{ height: 400 }}>
                  <Doughnut
                    data={orderCountChartNew}
                    options={chartOptions}
                  />
                </div>
              </div>
              <div className="mx-4 my-3 flex justify-content-center">
                <h4>Total Orders : {sumOfOrderCount}</h4>
              </div>
            </div>
          ) : (
            <div className="flex flex-1 justify-content-center align-items-center">
              <p className="text-3xl font-bold">No Orders Found</p>
            </div>
          )}
        </div>
        <div className="flex-1">
          <div
            className="flex-1  surface-0"
            style={{ "--surface-0": "#EAEFF5" }}
          >
            <div className="flex justify-content-center mx-4">
              <div className="py-1">
                <p className=" text-2xl  font-bold ">ALL ORDERS REVENUE</p>
              </div>
            </div>
          </div>

          {loading ? (
            <div className="flex flex-1 flex-column justify-content-center align-items-center">
              <ProgressSpinner />
              <p className="text-3xl font-bold">Loading Orders Revenue...</p>
            </div>
          ) : grandTotalChart.length > 0 ? (
            <div>
              <div className="mx-4 my-3 flex justify-content-center">
                <div className="flex " style={{ height: 400 }}>
                  <Doughnut
                    data={grandTotalChartNew}
                    options={chartOptions}
                  />
                </div>
              </div>
              <div className="mx-4 my-3 flex justify-content-center " >
                  <h4>Net Revenue : {storeLocalData?.currencySymbol} {sumOfGrandTotal.toFixed(2)}</h4>
              </div>
            </div>
          ) : (
            <div className="flex flex-1 justify-content-center align-items-center">
              <p className="text-3xl font-bold">No Sale Found</p>
            </div>
          )}
        </div>
      </div>
      <StoreFilterModal
          setStoreFilterModalVisible={setStoreSelectionModalVisible}
          storeFilterModalVisible={storeSelectionModalVisible}
          sendDataToOrdersPageFromFilter={receiveDataFromStoreSelectionModal}
          upDateSelectedStore={upDateSelectedStore}
          brandStoreData={brandStoreData}
        />
      <AnalyticsSchedularModal
        analyticsSchedularModalVisible={analyticsSchedularModalVisible}
        setAnalyticsSchedularModalVisible={setAnalyticsSchedularModalVisible}
        sendDataToOrdersPage={receiveDataFromSchedularModal}
      />
      <AdminMenu setVisible={setVisible} visible={visible} />
    </div>
  );
};

export default ProcessStatus;
